import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

export const CustomerReassignBulkFormSchema = z
  .object({
    assigneeIds: z.array(z.string().uuid()),
    assigneeMode: z.enum(['REPLACE', 'ADD', 'REMOVE']).nullable(),
  })
  .superRefine((values, context) => {
    if (isNil(values.assigneeMode)) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['assigneeMode'],
        message: i18n.t('general.validations.fieldIsRequired'),
      });
    }
    if (
      !isNil(values.assigneeMode) &&
      values.assigneeMode !== 'REPLACE' &&
      values.assigneeIds.length === 0
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['assigneeIds'],
        message: i18n.t('general.validations.fieldIsRequired'),
      });
    }
  });
